import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AutorizeChannelPayload,
  AutorizeChannelResponse,
  Channel,
  CreateChannelPayload,
  EstablishChannelPayload,
  EstablishChannelResponse,
  SubscriblyChannel,
  UpdateChannelPayload,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class ChannelApiService {
  constructor(private http: HttpClient) {}

  createChannel(payload: CreateChannelPayload): Observable<Channel> {
    return this.http.post<Channel>(`/channel?includeDetails`, payload);
  }

  getChannel(channelId: string): Observable<Channel> {
    return this.http.get<Channel>(`/channel/${channelId}`);
  }

  getChannels(
    workspaceId: string,
    includeDetails = true,
  ): Observable<Channel[]> {
    const query = includeDetails ? '?includeDetails' : '';
    return this.http.get<Channel[]>(`/channels/${workspaceId}${query}`);
  }

  updateChannel(
    channelId: string,
    payload: UpdateChannelPayload,
  ): Observable<Channel> {
    return this.http.patch<Channel>(`/channel/${channelId}`, payload);
  }

  deleteChannel(channelId: string): Observable<Channel> {
    return this.http.delete<Channel>(`/channel/${channelId}`);
  }

  refreshChannel(channelId: string): Observable<Channel> {
    return this.http.post<Channel>(`/channel/${channelId}/refresh`, {});
  }

  autorizeChannel(
    payload: AutorizeChannelPayload,
  ): Observable<AutorizeChannelResponse> {
    return this.http.post<AutorizeChannelResponse>(
      `/channel/authorize`,
      payload,
    );
  }

  establishChannels(
    payload: EstablishChannelPayload,
  ): Observable<EstablishChannelResponse[]> {
    return this.http.post<EstablishChannelResponse[]>(
      `/channels/establish`,
      payload,
    );
  }
}
